exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert[data-v-1de75ee0] {\n    margin-bottom: 16px;\n}\n", ""]);

// exports
